import calendarsAvailabilityDisplayController from "../../../calendars/assets/javascript/calendars-availability-display-controller";
import defaultAvailabilityDisplayChannel from "../../../../javascript/channels/availability/default_availability_display_channel";

export default class extends calendarsAvailabilityDisplayController {

  get channelCreator() {
    return defaultAvailabilityDisplayChannel
  }

  get updateEventName() {
    return "default-availability-display:update"
  }
}



// WEBPACK FOOTER //
// ./app/components/user_availabilities/assets/javascript/user-availabilities-default-schedule-display-controller.js